<template>
  <div class="productCollection_content">
    <div
      class="productCollection_items"
      v-for="(item, index) in ProductModel.CollectionItems"
      :key="item.Id"
    >
      <div class="productCollection_index">{{ index + 1 }}</div>
      <div class="productCollection_name" @click="DetailOrder(item)">
        <van-icon name="label-o" />{{ item.Name }}
      </div>
      <div class="productCollection_count">{{ item.Count }}</div>

      <div class="productCollection_price">
        {{ item.PriceFormat }}
      </div>

      <!-- <div class="productCollection_manage">
        <van-button
          type="primary"
          icon="minus"
          size="mini"
          @click="MinusCartItem(item)"
        >
        </van-button>
      </div> -->
    </div>
    <div class="productCollection_editcontent">
      <van-button
        @click="editCollection(ProductModel)"
        type="primary"
        icon="plus"
        size="mini"
      >
        {{ tools.GetLanguageValue("public.app.新增") }}
      </van-button>
    </div>
  </div>

  <!-- 详细信息 -->
  <van-action-sheet
    v-model:show="DetailOrderWindow"
    :title="tools.GetLanguageValue('public.app.详细信息')"
  >
    <AttributeParamsMoudule :Model="CartItemOpt" />
  </van-action-sheet>
</template>
<script >
import axios from "../commons/AxiosMethod.js"
import commons from "../commons/commons.js"
import AttributeParamsMoudule from "../components/AttributeParamsMoudule.vue"
import { showToast } from "vant"

export default {
  data () {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,

      DetailOrderWindow: false, // 详细信息页面
      CartItemOpt: {}, // 选中购物车项目

      UserInfo: {}, // 用户信息
      ProductModel: {}
    }
  },
  name: "App",
  mounted () {
    this.ProductModel = this.Model
  },
  props: {
    Model: {}
  },
  components: {
    AttributeParamsMoudule
  },
  methods: {
    // 详细信息
    DetailOrder (item) {
      this.CartItemOpt = item

      this.DetailOrderWindow = true
    },
    // 编辑套餐
    editCollection (item) {
      this.$router.push({
        path: "CollectionItems",
        query: {
          cartId: item.Id,
          collectionId: item.ProductId
        }
      })
    },
    // 减少商品
    MinusCartItem (item) {
      axios.apiMethod(
        "/Shopping/ShoppingTrolley/MinusCartItem",
        "get",
        { Id: item.Id },
        (result) => {
          if (result.Code == 200) {
            if (result.Data) {
              this.$emit("GetShoppingCart")
              this.GetCartCollectionItem(item)
              //   this.GetShoppingCartComplete();
            }
          }
          showToast(result.Msg)
        },
        (e) => {}
      )
    },
    GetCartCollectionItem (item) {
      axios.apiMethod(
        "/Shopping/ShoppingTrolley/GetCartCollectionItem",
        "get",
        { Id: item.CollectionFid },
        (result) => {
          if (result.Code == 200) {
            this.ProductModel.CollectionItems = result.Data
            //   this.GetShoppingCartComplete();
          }
        },
        (e) => {}
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.productCollection_content {
  min-height: 400px;
  padding: 10px;
  position: relative;
  .productCollection_items {
    color: rgb(88, 88, 88);
    display: flex;
    justify-content: space-between;
    width: calc(100% - 20px);
    margin: 0 auto;
    border-bottom: 1px solid #eee;
    margin-top: 8px;
    .productCollection_index {
      font-size: 9pt;
      width: 20px;
    }

    .productCollection_name {
      font-size: 10pt;
      width: 30%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .productCollection_count {
      font-size: 10pt;
    }
    .productCollection_price {
      color: red;
      text-decoration: line-through;
    }
  }

  .productCollection_editcontent {
    position: absolute;
    bottom: 10px;
    right: 20px;
  }
}
</style>
